/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakers: NonNullable<unknown>, recipients: NonNullable<unknown> }} Ccsl_Export_Speaker_To_RecipientInputs */



/**
* | output |
* | --- |
* | "{speakers} TO: {recipients}" |
*
* @param {Ccsl_Export_Speaker_To_RecipientInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_speaker_to_recipient = /** @type {((inputs: Ccsl_Export_Speaker_To_RecipientInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Speaker_To_RecipientInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.speakers} TO: ${i?.recipients}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.speakers} bis: ${i?.recipients}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.speakers} A: ${i?.recipients}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.speakers} К: ${i?.recipients}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.speakers} A: ${i?.recipients}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.speakers} 至：${i?.recipients}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.speakers} 宛先: ${i?.recipients}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.speakers} से: ${i?.recipients}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.speakers} PARA: ${i?.recipients}`)
	return /** @type {LocalizedString} */ (`${i?.speakers} TO: ${i?.recipients}`)
});